/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_HochschuleInputs */

const de__field_hochschule = /** @type {(inputs: _Field_HochschuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochschule`)
};

/**

* @param {_Field_HochschuleInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_hochschule = /** @type {((inputs?: _Field_HochschuleInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_HochschuleInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_hochschule(inputs)
});